<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar color="grey lighten-3" fixed height="100%" elevation="0">
        <a :href="anuncio()">
          <img
            class="shrink mr-5 hidden-sm-and-down"
            contain
            src="../assets/logotipo_chame_cinza.png"
            width="200"
          />
        </a>
        <v-row no-gutters>
          <v-col cols="12">
            <span class="subtitle-2 mr-2">Peça</span>
          </v-col>
          <v-col cols="12">
            <span class="subtitle-1 font-weight-black"
              >{{ item.fitStrCoditefabricante }} - {{ item.fitStrNme }}</span
            >
          </v-col>
        </v-row>

        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            icon
            @click="
              quantidade = 1;
              $emit('dialogfalse', false);
            "
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-content>
        <v-card class="elevation-0 px-6">
          <v-card-text>
            <v-row>
              <v-col lg="5" md="12" sm="12">

                <div class="container">
                  <div
                    class="mySlides cursor"
                    style="
                      text-align: center !important;
                      height: 400px;
                      overflow: hidden;
                    "
                  >
                    <v-dialog
                      v-model="dialogImg"
                      max-width="70%"
                      persistent
                      fullscreen
                    >
                      <template v-slot:activator="{ on }">
                        <img
                          :src="imgSelect"
                          width="100%"
                          height="100%"
                          class="contain imagSelecionada"
                          v-on="on"
                          id="imagemSelecionanda"
                        />
                      </template>
                      <v-card
                        style="text-align: center !important; overflow: hidden"
                      >
                        <v-toolbar
                          dark
                          color="#414141"
                          style="
                            position: fixed !important;
                            width: 100% !important;
                          "
                          elevation="0"
                        >
                          <v-btn icon dark @click="closeDialog()">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            v-if="tamanhoUmPraUm !== ''"
                            text
                            color="grey lighten-1"
                            @click="tamanhoImagem(1)"
                            >[ 1:1 ]</v-btn
                          >
                          <v-btn
                            v-if="tamanhoUmPraUm !== ''"
                            text
                            color="grey lighten-1"
                            @click="tamanhoImagem(2)"
                            >[ 1:2 ]</v-btn
                          >
                          <v-btn
                            v-if="tamanhoUmPraUm !== ''"
                            text
                            color="grey lighten-1"
                            @click="tamanhoImagem(3)"
                            >[ 1:3 ]</v-btn
                          >
                          <v-btn
                            icon
                            x-large
                            color="var(--vs-azul-secundaria)"
                            class="mr2"
                            @click="zoomIn()"
                            ><i
                              class="las la-search-plus"
                              style="font-size: 30px"
                            ></i
                          ></v-btn>
                          <v-btn
                            icon
                            x-large
                            color="var(--vs-marrom-secundario)"
                            class="mr-2"
                            @click="zoomOut()"
                            ><i
                              class="las la-search-minus"
                              style="font-size: 30px"
                            ></i
                          ></v-btn>
                        </v-toolbar>
                        <div class="align-center row pt-2">
                          <div
                            class="column"
                            v-for="img in item.imagens"
                            :key="img.gpaIntCod"
                            style="
                              text-align: center !important;
                              height: 60px;
                              overflow: hidden;
                            "
                          >
                            <img
                              class="demo cursor contain"
                              :src="img.imagem"
                              width="100%"
                              height="100%"
                              @click="currentSlide(img.imagem)"
                            />
                          </div>
                        </div>

                        <div class="center">
                          <div class="conteudo-imagem">
                            <img
                              :src="imgSelect"
                              class="contain"
                              id="imagSelecionada"
                            />
                          </div>
                        </div>
                      </v-card>
                    </v-dialog>
                  </div>

                  <div class="row pt-2">
                    <div
                      class="column"
                      v-for="img in item.imagens"
                      :key="img.gpaIntCod"
                      style="
                        text-align: center !important;
                        height: 60px;
                        overflow: hidden;
                      "
                    >
                      <img
                        class="demo cursor contain"
                        :src="img.imagem"
                        width="100%"
                        height="100%"
                        @click="currentSlide(img.imagem)"
                      />
                    </div>
                  </div>
                </div>
              </v-col>

              <v-col lg="7" md="12" sm="12">
                <v-col lg="6" md="12" sm="12" class="pa-0">
                  <div v-if="!orcamento">
                    <div class="black--text font-weight-black">
                      <span>Descrição</span>
                    </div>
                    <div>
                      <span>{{ item.ancStrDescricao }}</span>
                    </div>
                    <div
                      v-if="item.ancIntQtd !== 0"
                      class="pt-2 caption black--text text-truncate"
                    >
                      Quantidade em estoque : {{ item.ancIntQtd }}
                    </div>
                    <div v-else class="pt-2 caption black--text text-truncate">
                      Produto indisponível
                    </div>
                    

                    <div class="headline black--text font-weight-black">
                      <span>{{ parseFloat(item.ancFltPrecoVendaDesconto).toFixed(2).replace('.', ',') | currency }}</span>
                    </div>
                  </div>
                </v-col>

                <v-row no-gutters>
                  <v-col lg="4" md="4" sm="12">
                    <v-card-actions class="pa-0">
                      <vs-button
                        color="#43A047"
                        animation-type="scale"
                        @click="adicionarCarrinho()"
                        v-if="!comprar && item.ancIntQtd !== 0"
                        class="pl-0"
                      >
                        <i
                          class="las la-shopping-cart"
                          style="font-size: 20px !important"
                        ></i>
                        <template>Adicionar ao carrinho</template>
                      </vs-button>

                      <vs-button
                        color="warning"
                        border
                        animation-type="scale"
                        @click="cadastrarAviso()"
                        v-else
                      >
                        <i
                          class="las la-info-circle"
                          style="font-size: 20px !important"
                        ></i>
                        <template>Avise-me quando chegar</template>
                      </vs-button>
                    </v-card-actions>
                  </v-col>

                  <v-col lg="8" md="8" sm="12">
                    <v-card-actions class="pa-0">
                      <vs-button
                        color="danger"
                        border
                        @click="$emit('dialogfalse', false), (quantidade = 1)"
                        animation-type="scale"
                        v-if="!comprar"
                      >
                        <i
                          class="las la-times"
                          style="font-size: 20px !important"
                        ></i>
                        <template>Fechar</template>
                      </vs-button>
                    </v-card-actions>
                  </v-col>
                </v-row>

                <!-- <OpcaoEntega />

                <CalcFrete
                  :pecaFrete="item"
                  v-if="tipoEntrega === 'FRT'"
                  class="mb-8"
                /> -->

                <v-form ref="form2" lazy-validation>
                  <v-simple-table class="hidden-sm-and-down">
                    <thead>
                      <tr>
                        <th class="text-left body-2">Quantidade</th>
                        <th class="text-left body-2" v-if="!orcamento">
                          Preço
                        </th>
                        <th class="text-left body-2" v-if="!orcamento">
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th class="text-left">
                          <v-text-field
                            min="1"
                            max="100"
                            :rules="[(v) => !!v || 'Quantidade é obrigatório']"
                            v-model="quantidade"
                            type="number"
                            style="width: 50px"
                            required
                          ></v-text-field>
                        </th>
                        <th class="text-left subtitle-2" v-if="!orcamento">
                          {{ parseFloat(item.ancFltPrecoVendaDesconto).toFixed(2).replace('.', ',') | currency }}
                        </th>
                        <th
                          class="text-left subtitle-2 font-weight-black"
                          v-if="!orcamento"
                        >
                          {{
                            parseFloat((item.ancFltPrecoVendaDesconto * quantidade)).toFixed(2).replace('.', ',')
                              | currency
                          }}
                        </th>
                      </tr>
                    </tbody>
                  </v-simple-table>

                  <div class="hidden-md-and-up">
                    <v-row no-gutters>
                      <v-col cols="12" class="d-flex">
                        <span class="body-2 font-weight-bold pt-6 pr-4"
                          >Qtd.</span
                        >
                        <span>
                          <v-text-field
                            min="1"
                            max="100"
                            :rules="[(v) => !!v || 'Quantidade é obrigatório']"
                            v-model="quantidade"
                            type="number"
                            style="width: 50px"
                            required
                          ></v-text-field>
                        </span>
                      </v-col>
                      <v-col cols="7">
                        <span class="pa-0">Preço unitário</span>
                      </v-col>
                      <v-col cols="5" class="d-flex justify-end">
                        <span
                          class="pa-0 pl-2 font-weight-black"
                          v-if="!orcamento"
                          >{{ parseFloat(item.ancFltPrecoVendaDesconto).toFixed(2).replace('.', ',') | currency }}</span
                        >
                      </v-col>
                      <v-col cols="7">
                        <span class="pa-0">Preço total</span>
                      </v-col>
                      <v-col cols="5" class="d-flex justify-end">
                        <span
                          class="pa-0 pl-2 font-weight-black black--text"
                          v-if="!orcamento"
                        >
                          {{
                            parseFloat((item.ancFltPrecoVendaDesconto * quantidade)).toFixed(2).replace('.', ',')
                              | currency
                          }}
                        </span>
                      </v-col>
                    </v-row>
                  </div>
                </v-form>
                <br />

                <v-expansion-panels v-if="!comprar">
                  <v-expansion-panel >
                    <v-expansion-panel-header class="font-weight-bold">ESTOQUE ATUAL</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-data-table
                          dense
                          :headers="headers"
                          :items="detalheEstoque"
                          item-key="filial.filIntCod"
                          :disable-pagination="true"
                        >
                        </v-data-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  
                  <v-expansion-panel>
                    <v-expansion-panel-header>MENSAGENS</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <Mensagens :anuncio="item" class="pl-6" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel
                    v-if="
                      item.pecaAplicabilidade !== undefined &&
                      item.pecaAplicabilidade.gpaStrAplicabilidade &&
                      item.pecaAplicabilidade.gpaStrAplicabilidade !== undefined
                    "
                  >
                    <v-expansion-panel-header>APLICABILIDADE</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list>
                        <template
                          v-for="(n,
                          index) in item.pecaAplicabilidade.gpaStrAplicabilidade.split(',')">
                          <div :key="index">
                            <v-list-item>
                              <v-list-item-content class="pt-0 pb-0">
                                <v-list-item-title class="body-2">{{n}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="pa-0"></v-divider>
                          </div>
                        </template>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-content>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Mensagens from "@/components/Mensagens.vue";
import CalcFrete from "@/components/CalcularFrete.vue";
import Alert from "../utils/alert";
import OpcaoEntega from "../components/OpcaoEntrega";

export default {
  data() {
    return {
      quantidade: 1,
      ancFltPrecoVendaDesconto: this.item.ancFltPrecoVendaDesconto,
      pecaFrete: null,
      dialogImg: false,
      slideIndex: 1,
      tamanhoUmPraUm: "",
      headers: [
        { text: "Filial", value: "filial.filStrNme" },
        { text: "Quantidade", value: "qtdEstoque", align: 'center' }
      ],
    };
  },
  computed: {
    ...mapGetters({
      debug: "core/debug",
      detalheEstoque: "anuncio/detalheEstoque",
      user: "cliente/user",
      usuarioLogado: "cliente/usuarioLogado",
      anuncios: "anuncio/anuncios",
      empresa: "anuncio/empresa",
      orcamento: "cliente/orcamento",
      tipoEntrega: "pedido/tipoEntrega",
      imgSelect: "anuncio/imgSelect",
    }),
  },
  methods: {
    currentSlide(img) {
      this.showSlides(this.slideIndex, img);
    },
    showSlides(n, img) {
      var i;
      var slides = document.getElementsByClassName("mySlides");
      var dots = document.getElementsByClassName("demo");
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
        if (dots[i].currentSrc === img) {
          this.$store.dispatch("anuncio/carregarImgSelect", dots[i].currentSrc);
          // dots[this.slideIndex - 1].className += " active";
          dots[i].className += " active";
        }
      }
      slides[this.slideIndex - 1].style.display = "block";
    },
    zoomIn() {
      var GFG = document.getElementById("imagSelecionada");
      var currHeight = GFG.clientHeight;
      if (this.tamanhoUmPraUm === "") {
        this.tamanhoUmPraUm = currHeight;
      }
      GFG.style.height = currHeight + 80 + "px";
    },
    zoomOut() {
      var GFG = document.getElementById("imagSelecionada");
      var currHeight = GFG.clientHeight;
      if (this.tamanhoUmPraUm === "") {
        this.tamanhoUmPraUm = currHeight;
      }
      GFG.style.height = currHeight - 80 + "px";
    },
    tamanhoImagem(el) {
      var GFG = document.getElementById("imagSelecionada");
      var currHeight = GFG.clientHeight;
      GFG.style.height = this.tamanhoUmPraUm * el + "px";
    },
    closeDialog() {
      var GFG = document.getElementById("imagSelecionada");
      var currHeight = GFG.clientHeight;
      GFG.style.height = this.tamanhoUmPraUm + "px";
      this.dialogImg = false;
      this.tamanhoUmPraUm = "";
    },
    adicionarCarrinho() {
      if (this.user) {
        this.$store.dispatch("pedido/adicionarCarrinho", {
          cliente: this.user,
          busuario: this.usuarioLogado,
          anuncio: this.item,
          carIntQtd: this.quantidade,
        });
        this.quantidade = 1;
        this.$emit("dialogfalse", false);
      } else {
        Alert.warn(
          "",
          "Favor fazer seu login no Chame o Vendedor para adicionar o item ao carrinho."
        );
        this.$router.push({ name: "login" });
      }
    },
    cadastrarAviso() {
      this.$store.dispatch("anuncio/cadastrarAviso", {
        busuario: this.usuarioLogado,
        anuncio: this.item,
      });
      this.$emit("dialogfalse", false);
    },
    anuncio() {
      return `/${this.$route.params.id}/anuncio`;
    },
    imagemPecas() {
      let imagens = [];
      if (this.item.imagens.length > 0) {
        this.item.imagens.forEach((img) => {
          let temp = {
            src: img.imagem,
            thumbnail: img.imagem,
          };
          imagens.push(temp);
        });
      } else {
        let temp = {
          src:
            "https://stgisvendas.blob.core.windows.net/imagem-peca/sem-imagem.jpg",
          thumbnail:
            "https://stgisvendas.blob.core.windows.net/imagem-peca/sem-imagem.jpg",
        };
        imagens.push(temp);
      }
      return imagens;
    },
  },

  props: ["dialog", "item", "comprar"],
  components: {
    Mensagens,
    CalcFrete,
    OpcaoEntega,
  },
};
</script>

<style scoped>
.v-content {
  padding: 0px !important;
}

#dialog-left {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  overflow-y: auto;
  top: 0;
  left: 0;
  width: 55% !important;
}

.v-image__image {
  margin-top: unset !important;
}

.contain {
  object-fit: contain;
}

.image {
  width: auto !important;
  height: 60px !important;
  background-size: contain !important;
  cursor: pointer;
  margin: 10px;
  border-radius: 3px;
}

.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  position: absolute;
}

.scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.card {
  width: 80px;
  height: 60px;
  background: white;
  /* margin-right: 3px; */
  display: inline-block;
}

.scrolling-wrapper,
.scrolling-wrapper-flexbox {
  width: 37%;
}

.shrink {
  width: 200px !important;
}

/* .inline-container-base-container,
.scroller-at-left {
  overflow: auto !important;
  max-width: fit-content;
  min-width: fit-content;
}

.pane-container {
    width: 100% !important;
}
.responsive-image.preview-box  {
    width: 100% !important;
    background-color: blue;
} */

/* Position the image container (needed to position the left and right arrows) */
.container {
  position: relative;
}

/* Hide the images by default */
.mySlides {
  display: block;
}

/* Add a pointer when hovering over the thumbnail images */
.cursor {
  cursor: pointer;
}

/* Next & previous buttons */
.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 40%;
  width: auto;
  padding: 16px;
  margin-top: -50px;
  color: white;
  font-weight: bold;
  font-size: 20px;
  border-radius: 0 3px 3px 0;
  user-select: none;
  -webkit-user-select: none;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

/* Number text (1/3 etc) */
.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

/* Container for image text */
.caption-container {
  text-align: center;
  background-color: #222;
  padding: 2px 16px;
  color: white;
}

.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Six columns side by side */
.column {
  float: left;
  width: 16.66%;
  padding: 0px 2px;
}

/* Add a transparency effect for thumnbail images */
.demo {
  opacity: 0.6;
}

.active,
.demo:hover {
  opacity: 1;
}

.position-absolute {
  position: absolute;
  left: 0;
}

.conteudo-imagem {
  overflow: auto;
  width: 100%;
  height: 600px;
  position: fixed;
}

.center {
  justify-content: center;
  display: flex;
  margin-top: 23px !important;
}

.align-center {
  justify-content: center;
  display: flex;
  margin-top: 64px !important;
}
.v-expansion-panel-content__wrap {
    padding: 0 8px 4px !important;
}
</style>
